import { signal, Signal } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function getDmFilesFields(
    disabled: boolean,
    translocoContent: Signal<any>
): FormlyFieldConfig[] {
    const prefix = 'systemTables.dmFiles.';
    if (!translocoContent()) {
        return [];
    }
    return [
        {
            fieldGroupClassName: 'flex flex-wrap gap-4',
            fieldGroup: [
                {
                    className: 'flex-2',
                    type: 'input',
                    key: 'wbs',
                    props: {
                        label: translocoContent()[prefix + 'wbs'],
                        required: true,
                        disabled: disabled,
                    },
                },
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'name',
                    props: {
                        label: translocoContent()[prefix + 'name'],
                        required: true,
                        disabled: disabled,
                    },
                },
            ],
        },
        {
            fieldGroupClassName: 'flex flex-wrap gap-4',
            fieldGroup: [
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'fileName',
                    props: {
                        label: translocoContent()[prefix + 'fileName'],
                        required: true,
                        disabled: disabled,
                    },
                },
                {
                    className: 'flex-2',
                    type: 'input',
                    key: 'type',
                    props: {
                        label: translocoContent()[prefix + 'type'],
                        required: true,
                        disabled: disabled,
                    },
                },
            ],
        },
        {
            fieldGroupClassName: 'flex flex-wrap gap-4',
            fieldGroup: [
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'businessDomain',
                    props: {
                        label: translocoContent()[prefix + 'businessDomain'],
                        required: true,
                        disabled: disabled,
                    },
                },
                {
                    className: 'flex-1',
                    type: 'input',
                    key: 'technology',
                    props: {
                        label: translocoContent()[prefix + 'technology'],
                        required: true,
                        disabled: disabled,
                    },
                },
            ],
        },

        {
            className: 'flex-1',
            type: 'input',
            key: 'storageLocation',
            props: {
                label: translocoContent()[prefix + 'storageLocation'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'checkbox',
            key: 'mFile',
            props: {
                label: translocoContent()[prefix + 'mFile'],
                disabled: disabled,
            },
        },
        {
            fieldGroupClassName: 'flex flex-wrap gap-4',
            fieldGroup: [
                {
                    className: 'flex-1 ',
                    type: 'textarea',
                    key: 'link',
                    props: {
                        label: translocoContent()[prefix + 'link'],
                        required: true,
                        disabled: disabled,
                    },
                },
                {
                    className: 'flex-2',
                    type: 'copy-button',
                    key: 'link',
                    props: {
                        label: translocoContent()[prefix + 'size'],
                        required: true,
                        disabled: disabled,
                        icon: 'heroicons_outline:document-duplicate',
                        translocoContent: translocoContent,
                    },
                },
                {
                    className: 'flex-2',
                    type: 'link-button',
                    key: 'link',
                    props: {
                        label: translocoContent()[prefix + 'size'],
                        required: true,
                        disabled: disabled,
                        icon: 'heroicons_outline:link',
                        translocoContent: translocoContent,
                    },
                },
            ],
        },

        // {
        //     className: 'flex-1',
        //     type: 'input',
        //     key: 'metadata',
        //     props: {
        //         label: translocoContent()[prefix + 'metadata'],
        //         required: false,
        //         disabled: disabled,
        //     },
        // },
        {
            className: 'flex-1 hidden',
            type: 'input',
            key: 'description',
            props: {
                label: translocoContent()[prefix + 'description'],
                required: false,
                disabled: disabled,
            },
            defaultValue: '',
        },
    ];
}
